"use client";

import Cards from "@/components/content/cards";
import React from "react";
import { Card, CardBody } from "@nextui-org/react";
import InfiniteScroll from "@/components/common/infinitePagination";
import { useCategoryContentList } from "@/helpers/hooks/useCategory";

const FreePage = ({ data = {} }) => {
  
  const { items, hasMore, onLoadMore } = useCategoryContentList({
    fetchDelay: 0,
    slug: "free",
    initialPage: 1,
    pageSize: 20,
    autoInit: false,
    initialData: data?.results,
    lazyLoading: true,
  });

  return (
    <>
      <div className="h-[27vh] flex justify-start items-end md:container mx-auto px-5">
        <h2 className="font-medium sm:font-bold md:font-extrabold lg:font-black text-[#F0F0F0] text-3xl md:text-4xl lg:text-5xl z-10">
          مفته باخ
        </h2>
      </div>
      <div className="w-full min-h-[60vh] md:container mx-auto px-5">
        <div className="my-12 md:my-20">
          {items?.length > 0 ? (
            <InfiniteScroll hasMore={hasMore} loadMore={onLoadMore}>
              <Cards
                items={items?.reduce(
                  (acc, i) =>
                    acc.concat({
                      content: i,
                    }),
                  []
                )}
                isArtist={false}
                noTag={false}
                isMusic={false}
                showTitle={true}
                noMX={true}
                noContainer={true}
                type="movie"
              />
            </InfiniteScroll>
          ) : (
            <div className="w-full flex justify-center items-center pt-16">
              <Card className="dark px-24 py-5">
                <CardBody>
                  <span className="font-extrabold xs:text-lg sm:text-xl md:text-2xl text-[#BFBFBF]">
                    محتوایی یافت نشد.
                  </span>
                </CardBody>
              </Card>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default FreePage;
